import { render } from "./AddNewFileModal.vue?vue&type=template&id=4a7310e4&ts=true"
import script from "./AddNewFileModal.vue?vue&type=script&lang=ts"
export * from "./AddNewFileModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__